import React from 'react';
import './table.css';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { Info, Edit, Person } from '@material-ui/icons';
import CloseIcon from '@material-ui/icons/Close';
import CheckCircle from '@material-ui/icons/CheckCircle';
import LocalPhoneIcon from '@material-ui/icons/LocalPhone';
import Tooltip from '@material-ui/core/Tooltip';
import 'antd/dist/antd.css';
import { MDBIcon } from "mdbreact";

import { Popconfirm, Empty, Spin, Image, Checkbox } from 'antd';
import allStrings from '../../assets/strings'
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'

import { ChangeLanguage } from '../../redux/actions/LanguageAction'

class Table extends React.Component {
  state = {
    data2: [],
    selectedRows: []
  }
  constructor(props) {
    super(props)
    console.log('hhhh', this.props)
    if (this.props.isRTL) {

      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }

  componentDidMount() {
    this.setState({ data2: this.props.data2 })
    console.log('hhhh')
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = this.props.data.map((n, index) => ({
        id: this.props.isRTL ? this.props.data2[index][this.props.data2[index].length - 1] : this.props.data2[index][0],
        data: n,
      }));
      this.setState({ selectedRows: newSelecteds });
      return;
    }
    this.setState({ selectedRows: [] });
  };

  handleRowClick = (event, id, rowData) => {
    console.log("id : ", id)
    const { selectedRows } = this.state;
    console.log("bselectedRows :", selectedRows)
    const selectedIndex = selectedRows.findIndex((row) => row.id === id);
    console.log("selectedIndex :", selectedIndex)
    let newSelected = [];

    if (selectedIndex === -1) {
      console.log("is -")
      newSelected = newSelected.concat(selectedRows, { id: id, data: rowData });
    } else {
      console.log("is not -")
      newSelected = selectedRows.filter((row) => row.id !== id);
    }

    this.setState({ selectedRows: newSelected });
    console.log("newSelected :", newSelected)
  };

  handleBulkDelete = () => {
    const { selectedRows } = this.state;
    this.props.deleteItem(selectedRows.map(row => row.id));
    this.setState({ selectedRows: [] });
  };

  handleBulkAssign = () => {
    const { selectedRows } = this.state;
    console.log("selectedRows.map(row => row.data)", selectedRows.map(row => row.data))
    this.props.assignedToModal(selectedRows.map(row => row.data));
    this.setState({ selectedRows: [] });
  };



  render() {
    let { dataCount, noDelete, enableEdit, settings, filter, title, icon, data, data2, tableColumns, loading, deleteItem, enableContact, contact, enableAssigne, assignedToModal, path,/*reload,csv,searchInput*/ } = this.props
    let isReload = data2.length > 0 ? this.props.data2[0][0] : "";
    if (!dataCount) dataCount = 0
    let { selectedRows } = this.state;
    const numSelected = selectedRows.length;

    const isSelected = (id) => selectedRows.some(row => row.id === id);
    return (
      <div>
        <div className="table">
          <Card className="tableCard" style={{ overflow: 'visible', outline: 'none', marginBottom: '0px' }}>
            <CardHeader></CardHeader>
            <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
              <div className="topIcon" style={{ background: 'linear-gradient(135deg, #1D9598, #127275)' }}>
                <span className="material-icons" style={{ color: 'white', fontSize: 20 }}>{icon}</span>
              </div>
              <div className="tableTitle" style={{
                display: 'inline-block', marginTop: this.props.isRTL ? '-8px' : '-10px',
                marginLeft: this.props.isRTL ? '0' : '0rem', marginRight: this.props.isRTL ? '0rem' : '0'
              }}>
                <p>{title}</p>

              </div>
            </div>
            <div style={{ textAlign: this.props.isRTL ? 'start' : 'end', padding: '8px' }}>
              {settings}
            </div>
            {dataCount > 0 &&
              <div>
                <p style={{ top: '135px', position: 'absolute', padding: '4px 80px', left: this.props.isRTL ? '' : '0', right: this.props.isRTL ? '0' : '', fontWeight: '500', fontSize: '35px', color: '#1D9598' }}>
                  {dataCount}
                </p>
              </div>
            }
            <div>
              {filter}
            </div>

            {numSelected > 0 && (
              <div style={{ margin: '10px', display: 'flex', alignItems: 'center', justifyContent: this.props.isRTL ? 'flex-end' : 'flex-start' }}>
                <span style={{ marginRight: '15px', color: '#1D9598', fontWeight: 'bold' }}>
                  {allStrings.selected} <span style={{ display: 'inline-block' }}>{numSelected}</span>
                </span>
                {noDelete !== true &&
                  <span style={{ margin: "0 8px", cursor: 'pointer' }}>
                    <Tooltip title={allStrings.areYouSureDelete} placement="top" arrow>
                      <Popconfirm title={allStrings.areYouSureDelete} okText={allStrings.yes} cancelText={allStrings.no}
                        onConfirm={this.handleBulkDelete}>
                        <MDBIcon className="customBtnRemove mr-2" icon="trash-alt" />
                      </Popconfirm>
                    </Tooltip>
                  </span>
                }
                {enableAssigne === true &&
                  <MDBIcon className="customBtnBlue mr-2" icon="user" onClick={this.handleBulkAssign} />
                }
              </div>
            )}
            <CardContent style={{ minHeight: "390px", outline: 'none' }}>
              {loading ?
                <div className='loading'>
                  <Spin tip={allStrings.loading} size="large" style={{ color: '#1D9598' }}></Spin>
                </div>
                :
                <div className="table-responsive">
                  <table className="table">
                    <thead>
                      <tr>
                        {this.props.isRTL
                          ? [
                            ...[...tableColumns].reverse().map((item, index) => (
                              <th scope="col" key={index} style={item === allStrings.action ? { width: '99px', minWidth: '99px' } : {}}>{item}</th>
                            )),
                            <th key="checkbox" style={{ width: '50px' }}></th>
                          ]
                          : [
                            <th key="checkbox" style={{ width: '50px' }}></th>,
                            ...tableColumns.map((item, index) => (
                              <th scope="col" key={index} style={item === allStrings.action ? { width: '99px', minWidth: '99px' } : {}}>{item}</th>
                            ))
                          ]
                        }
                      </tr>

                    </thead>

                    <tbody>
                      {data2.length > 0 ? data2.map((item, index) => {
                        var id = item[item.length - 1] == "action" ? item[0] : item[item.length - 1];
                        const isItemSelected = isSelected(id);
                        const rowData = data[index];

                        return (
                          <tr
                            key={index}
                            onClick={(event) => this.handleRowClick(event, id, rowData)}
                            style={{ background: isItemSelected ? 'linear-gradient(135deg, #b3e2e3, #c9eff9)' : '', cursor: 'pointer' }}
                          >
                            {!this.props.isRTL && (
                              <td>
                                <Checkbox
                                  checked={isItemSelected}
                                  onChange={(e) => this.handleRowClick(e, id, rowData)}
                                  className="custom-checkbox"
                                />
                              </td>
                            )}

                            {(this.props.isRTL && Number.isInteger(isReload) ? item.reverse() :
                              this.props.isRTL && !Number.isInteger(isReload) ? item :
                                !Number.isInteger(isReload) ? item.reverse() : item).map((val, i) =>
                                  val === 'action'
                                    ? (
                                      this.state.selectedRows.length > 0
                                        ? <td key={i}></td>
                                        : <td key={i}>
                                          {noDelete !== true &&
                                            <span style={{ margin: "2px", cursor: 'pointer' }}>
                                              <Tooltip title={allStrings.areYouSureDelete} placement="top" arrow>
                                                <Popconfirm
                                                  title={allStrings.areYouSureDelete}
                                                  okText={allStrings.yes}
                                                  cancelText={allStrings.no}
                                                  onConfirm={() => {
                                                    this.props.isRTL ? deleteItem(item[item.length - 1]) : deleteItem(item[0])
                                                  }}
                                                >
                                                  <CloseIcon color="secondary" style={{ fontSize: '22px' }} />
                                                </Popconfirm>
                                              </Tooltip>
                                            </span>
                                          }

                                          {enableContact === true
                                            ? (item[3].value === "بالانتظار" || item[4].value === "Pending" || item[2].value === "جديد" || item[7].value === "New")
                                              ? (
                                                <span style={{ margin: "2px", cursor: 'pointer' }}>
                                                  <Tooltip title={allStrings.areYouSure} placement="top" arrow>
                                                    <Popconfirm
                                                      title={allStrings.areYouSure}
                                                      okText={allStrings.yes}
                                                      cancelText={allStrings.no}
                                                      onConfirm={() => {
                                                        this.props.isRTL ? contact(item[item.length - 1]) : contact(item[0])
                                                      }}
                                                    >
                                                      <LocalPhoneIcon color="success" style={{ fontSize: '22px', color: 'blue' }} />
                                                    </Popconfirm>
                                                  </Tooltip>
                                                </span>
                                              )
                                              : (
                                                <CheckCircle color="success" style={{ fontSize: '20px', color: 'green' }} />
                                              )
                                            : null
                                          }

                                          {enableAssigne === true &&
                                            <span
                                              onClick={() => { this.props.assignedToModal(data[index]) }}
                                              style={{ margin: "2px", cursor: 'pointer' }}
                                            >
                                              <Tooltip title={allStrings.assignedTo} placement="top" arrow>
                                                <Person style={{ color: '#3b82f6', fontSize: '20px' }} />
                                              </Tooltip>
                                            </span>
                                          }

                                          <span onClick={() => { this.props.history.push(path, { data: data[index] }) }} style={{ margin: "2px", cursor: 'pointer' }}>
                                            <Tooltip title={allStrings.info} placement="top" arrow>
                                              <Info style={{ color: '#33d633', fontSize: '20px' }} />
                                            </Tooltip>
                                          </span>

                                          {enableEdit !== false &&
                                            <span onClick={() => { this.props.history.push(path, { data: data[index], actionType: 'EDIT' }) }} style={{ margin: "2px", cursor: 'pointer' }}>
                                              <Tooltip title={allStrings.edit} placement="top" arrow>
                                                <Edit style={{ color: 'cornflowerblue', fontSize: '20px' }} />
                                              </Tooltip>
                                            </span>
                                          }
                                        </td>
                                    )
                                    : val.type === "img"
                                      ? <Image
                                        key={i}
                                        width="50px"
                                        height="50px"
                                        placeholder={true}
                                        style={{ borderRadius: '50%', width: "50px", height: '50px', padding: '5px' }}
                                        src={val.img !== "" ? val.img : require('../../assets/images/profileicon.jpg')}
                                      />
                                      : val.type === "tag"
                                        ? <td key={i}><p className="tag">{val.value}</p></td>
                                        : <td key={i} onClick={() => { this.props.history.push(path, { data: data[index] }) }}>{"" + val}</td>
                                )}

                            {this.props.isRTL && (
                              <td>
                                <Checkbox
                                  checked={isItemSelected}
                                  style={{ color: '#1D9598' }}
                                />
                              </td>
                            )}
                          </tr>
                        )
                      }) : (
                        <tr style={{ height: '200px' }}>
                          <th colSpan="10" className="noData">
                            <Empty description={allStrings.noData} style={{ margin: '2rem auto' }} />
                          </th>
                        </tr>
                      )}
                    </tbody>
                  </table>

                </div>
              }
            </CardContent>
          </Card>
        </div>
      </div>
    )
  }
}

const mapToStateProps = state => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
})

const mapDispatchToProps = {
  ChangeLanguage
}

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(Table)
);

